import { Badge } from "@mui/material";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import Menu from "src/components/Default/LekUI/Menu";
import EditIcon from "src/images/Icons/newIcons/exam/more/edit.svg";
import ErrorIcon from "src/images/Icons/newIcons/exam/more/error.svg";
import LevelIcon from "src/images/Icons/newIcons/exam/more/level.svg";
import StatsIcon from "src/images/Icons/newIcons/exam/more/stats.svg";
import MoreIcon from "src/images/Icons/newIcons/exam/options/more.svg";

import Option from "./Option";

function More({ actions, details, ...props }) {
	const { t } = useTranslation();
	const { visibility } = details;

	const toggle = (key) => {
		return props.dispatch(actions.toggleSettings(key));
	};

	const renderIcon = () => {
		return (
			<div className="question--options--item">
				<Badge
					badgeContent={details.isNote ? 1 : 0}
					color="secondary"
					invisible={!details.isNote}
					className="question--options--item--badge"
				>
					<MoreIcon className="icon-normal" />
				</Badge>
				<div className="flex flex-col items-center">
					<span className="size-14-light">{t("exam.more")}</span>
					<p className="size-12-light m-0">&nbsp;</p>
				</div>
			</div>
		);
	};

	return (
		<Option>
			<Menu
				icon={renderIcon()}
				anchorId="options-list-actions"
				closeAfterClick
				buttonClassName="w-100 h-100 menu-option-icon-button size-16-light"
				buttonTestId="question-more-button"
				menuPopperClassName="z-index-9999"
				className="h-100"
				items={[
					{
						Icon: <ErrorIcon className="icon-small" />,
						title: t("exam.reportError.title"),
						testId: "question-option-report-error",
						onClick: () => {
							return toggle("reportError");
						},
					},
					{
						Icon: <StatsIcon className="icon-small" />,
						title: t("exam.stats"),
						testId: "question-option-statistics",
						onClick: () => {
							return toggle("statistics");
						},
						selected: props.settings.statistics,
						disabled: !visibility?.statistics,
					},
					{
						Icon: <LevelIcon className="icon-small" />,
						title: t("exam.questionLevel"),
						testId: "question-option-level",
						onClick: () => {
							return toggle("questionLevel");
						},
						selected: props.settings.questionLevel,
						disabled: !visibility?.level,
					},
					{
						Icon: (
							<Badge
								variant="dot"
								color="secondary"
								invisible={!details.isNote}
								sx={{ span: { margin: "0 !important" } }}
							>
								<EditIcon className="icon-small" />
							</Badge>
						),
						title: t("exam.notes.title"),
						testId: "question-option-notes",
						onClick: () => {
							return toggle("notes");
						},
					},
				]}
				Component={Button}
			/>
		</Option>
	);
}

export default More;
